import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";
import { ThemeProvider } from "./theme/ThemeProvider";
import { useEffect } from "react";
import AssistantWidget from "./components/AssistantWidget";

function AppShell() {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18nInstance.resolvedLanguage || "pt-BR";
  }, [i18nInstance, i18nInstance.resolvedLanguage]);

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AssistantWidget />
      <AppRoutes />
    </BrowserRouter>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <AppShell />
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;
